import React from "react";
import { Box, Toolbar } from "@mui/material";
import Header from "components/Header/Header";
import Footer from "components/Footer/Footer";
import { useSelector } from "react-redux";

const AuthLayout = ({ children }) => {
  const { isAuthenticated } = useSelector((state) => state.auth);

  return (
    <Box
      className="auth-layout"
      sx={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column'
      }}
    >
      <Header />
      <Box
        component="main"
        className="auth-content"
        sx={{
          flex: 1,
          marginLeft: isAuthenticated ? "60px" : 0,
          width: isAuthenticated ? "calc(100% - 60px)" : "100%",
          transition: "margin-left 0.3s ease, width 0.3s ease",
          "@media (max-width: 768px)": { marginLeft: 0, width: "100%" },
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Toolbar />
        <Box
          sx={{
            flex: 1,
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          {children}
        </Box>
        <Footer />
      </Box>
    </Box>
  );
};

export default AuthLayout;
